import Vue from 'vue'
import moment from 'moment'
import 'moment-timezone'

declare module 'vue/types/vue' {
  interface Vue {
    $moment: (
      inp?: moment.MomentInput,
      format?: moment.MomentFormatSpecification,
      language?: string,
      strict?: boolean
    ) => moment.Moment
  }
}

export default function MomentPlugin(V: typeof Vue) {
  V.prototype.$moment = function(
    inp?: moment.MomentInput,
    format?: moment.MomentFormatSpecification,
    language?: string,
    strict?: boolean
  ): moment.Moment {
    return moment(inp, format, language, strict)
  }

  V.prototype.$local = function(
    inp?: moment.MomentInput,
    format?: string,
    language?: string,
    strict?: boolean
  ): moment.Moment {
    const localTime = moment.utc(inp).local()
    return moment(localTime, format, language, strict)
  }
}
